module.exports = __webpack_public_path__ + "img/hero-image-compra.37614dc7.png";